/**
 * Человекочитаемое название дистанции по коду из `Goal.race_distance`.
 *
 * В базе лежит КОД, а не текст: `"5k" | "10k" | "half" | "marathon" |
 * "tri.half" | "70.3" | "custom" | …` (перечисление — в
 * `shared/domain/taper.py` и `shared/services/race_forecast_service.py:229`).
 * Кто печатает поле напрямую, показывает атлету слово «half».
 *
 * Ключи словаря `goal:distance.*` не содержат точек (точка — разделитель
 * уровней в i18next), поэтому `tri.half` → `distance.tri_half`,
 * `70.3` → `distance.70_3`.
 */

/** Ключ словаря для кода дистанции; null — когда кода нет. */
export function raceDistanceI18nKey(code: string | null | undefined): string | null {
  const normalized = code?.trim();
  if (!normalized) return null;
  return `distance.${normalized.replace(/\./g, "_")}`;
}

/**
 * Название дистанции. `translate` — функция вида `t(key, { defaultValue })`
 * из неймспейса `goal`. Незнакомый код возвращается как есть: у тренера
 * дистанция бывает произвольной строкой, и потерять её хуже, чем показать.
 */
export function formatRaceDistance(
  code: string | null | undefined,
  translate: (key: string, options: { defaultValue: string }) => string,
): string {
  const key = raceDistanceI18nKey(code);
  if (!key) return "";
  const raw = code!.trim();
  return translate(key, { defaultValue: raw });
}
